import {
  DateCell,
  DateFormats,
  Icon,
  Inline,
  Table,
  Tooltip,
  Typography,
} from '@omnipresentgroup/design-system';
import { useLegalEntity } from '@omnipresentgroup/domains';
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';

const HELP_TEXT =
  'The next cutoff report date indicates the deadline for clients to submit any requests, such as salary changes or bonuses, to be included in the upcoming payroll. This date is prominently displayed in the UI across multiple pages for easy reference.';

const EMPTY_ARRAY: string[] = [];
const LOADING_ARRAY = Array.from({ length: 6 }, () => ({}) as string);

const COLUMN_HELPER = createColumnHelper<string>();

export const LegalEntityNextCutoffDates = ({
  legalEntityId,
}: {
  legalEntityId: string;
}) => {
  const { data: legalEntity, isLoading } = useLegalEntity({
    id: legalEntityId,
    enabled: Boolean(legalEntityId),
  });

  const table = useReactTable({
    data: isLoading
      ? LOADING_ARRAY
      : legalEntity?.nextCutoffDates || EMPTY_ARRAY,
    columns: [
      COLUMN_HELPER.display({
        id: 'date',
        cell: (info) => (
          <DateCell
            value={info.row.original}
            dateFormat={DateFormats.DateTime}
            showTimezone
          />
        ),
        header: () => (
          <Inline align="center" gap="4">
            <Typography as="span" size="14" weight="medium">
              Next cutoff dates
            </Typography>
            <Tooltip id="next-cutoff-dates-tooltip" description={HELP_TEXT}>
              <Icon size="16" icon="Help" title="" />
            </Tooltip>
          </Inline>
        ),
      }),
    ],
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Table
      id="legal-entity-next-cutoff-dates-list"
      table={table}
      loading={isLoading}
      wrapperProps={{
        id: 'legal-entity-next-cutoff-dates-list-wrapper',
        maxH: 338, // calculated to fit 6 items
      }}
    />
  );
};
